export default __webpack_public_path__ + "static/media/logo.66c49d5c.png";